import ACTION_TYPES from "../actions/actionTypes";

export default (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_FPY_MISS_REASON_PARETO_DATA:
      return { ...state, fpyMissReasonParetoData: action.payload };
    case ACTION_TYPES.GET_METRIC_ANDON:
      return { ...state, metricsAndonData: action.payload };
    case ACTION_TYPES.FETCH_SHIFT_LIST: {
      let response = action.payload;
      response.shifts = JSON.parse(response.shifts);
      return { ...state, shiftDetails: response };
    }
    case "FPY_REASONS":
      return { ...state, FPYReasons: action.payload };
    case "DLE_REASONS":
      return { ...state, dleReasons: action.payload };
    case "FETCH_FPY_TARGET":
      return { ...state, shiftDetails: action.payload };
    case "FETCH_FPY_SHIFT":
      return { ...state, shiftInfo: action.payload };
    case "REFRESH_FPY_WIDGET": {
      return { ...state, refreshFpy: action.payload };
    }
    case "FETCH_REASON_CODE_LEVEL_O": {
      return { ...state, level0Codes: action.payload };
    }
    case "FETCH_REASON_CODE_LEVEL_1": {
      return { ...state, level1Codes: action.payload };
    }
    case "FETCH_REASON_CODE_LEVEL_2": {
      return { ...state, level2Codes: action.payload };
    }
    default:
      return state;
  }
};
